<template>
  <transition appear @after-enter="afterEnter">
    <div v-if="isVisible" class="c-proposal" v-click-outside="clickOutside">
      <transition mode="out-in">
        <div v-if="isActive" class="c-proposal-box">
          <transition name="v-fade" mode="out-in">
            <div v-if="isThanks" key="thanks" class="c-proposal-box__inner">
              <div class="c-proposal-box__header">
                <router-link
                  :to="{ name: 'taskListProposals' }"
                  class="c-proposal-box__link"
                >
                  <Icon2 color="white" variant="task_link" :size="12" />
                </router-link>
              </div>
              <div class="c-proposal-box__content">
                <ProposalThanks :proposals="proposals" @next="hideThanks" />
              </div>
            </div>
            <div v-else key="improvement" class="c-proposal-box__inner">
              <div class="c-proposal-box__header">
                <h2 class="c-proposal-box__title">
                  SEARCH WRITEからの改善の提案
                </h2>
                <router-link
                  :to="{ name: 'taskListProposals' }"
                  class="c-proposal-box__link"
                >
                  <Icon2 color="white" variant="task_link" :size="12" />
                </router-link>
              </div>
              <div class="c-proposal-box__content">
                <transition name="v-fade" mode="out-in">
                  <ProposalContent
                    :key="proposal.id"
                    :project="project"
                    :proposal="proposal"
                    @accept="acceptProposal"
                    @focus="focus"
                    @reject="rejectProposal"
                  />
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </transition>
      <Button variant="light" class="c-proposal__btn" @click="toggle">
        <Icon2 v-if="isActive" key="close" variant="close" :size="16" />
        <template v-else>
          <Icon2 key="open" variant="hint" :size="30" />
          提案
        </template>
      </Button>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import ProposalContent from '@/components/proposal/ProposalContent';
import ProposalThanks from '@/components/proposal/ProposalThanks';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    proposal: {
      type: Object,
      required: false
    },
    proposals: {
      type: Array,
      required: true
    }
  },
  components: {
    Button,
    Icon2,
    ProposalContent,
    ProposalThanks
  },
  data() {
    return {
      isActive: false,
      isAppeared: false,
      isThanks: false
    };
  },
  computed: {
    isVisible() {
      return this.proposal || this.isThanks;
    }
  },
  watch: {
    isActive: {
      handler() {
        if (this.isActive) {
          this.closeTask();
        } else if (this.isThanks) {
          // タスク登録後にポップアップを閉じたら、改善提案を非表示にする
          this.isThanks = false;
        }
      }
    },
    isVisible: {
      handler() {
        if (this.isVisible && this.isActive) {
          this.closeTask();
        }
      },
      immediate: true
    }
  },
  methods: {
    afterEnter() {
      this.isAppeared = true;
    },
    clickOutside() {
      this.blur();
      this.close();
    },
    close() {
      // 初回の表示アニメーションが終わるまでは、画面をどこかクリックしても閉じないようにする
      if (!this.isAppeared) {
        return;
      }
      this.isActive = false;
    },
    closeTask() {
      this.$store.dispatch('task/setStatus', { isActive: false });
    },
    toggle() {
      this.isActive = !this.isActive;
    },
    focus() {
      this.close();
      this.$emit('focus');
    },
    blur() {
      this.$emit('blur');
    },
    acceptProposal() {
      this.showThanks();
      this.removeProposal();
    },
    rejectProposal() {
      this.removeProposal();
    },
    removeProposal() {
      this.$emit('remove', this.proposal);
      this.blur();
    },
    showThanks() {
      this.isThanks = true;
    },
    hideThanks() {
      this.isThanks = false;
    }
  }
};
</script>
